import React from 'react';
import map from 'lodash/map';
import { InputField, Field } from '../form';

import NetworkIcon from './NetworkIcon';
import DropdownSelectAdapter from '../form/DropdownSelectAdapter';
import { Button } from 'reactstrap';



const SchemedField = ({nodropdown, name, fieldValue, placeholder, scheme, submitting, selectedFields}) => {
  
  const fieldType = fieldValue.type || 'default'
  const itemSettings = scheme[fieldType] || {};
  const { subfields } = itemSettings;
  
  return (<div className="input-stack">
    <div className="input-group input-stack-row">{ nodropdown ?
      <div className="input-group-prepend"><Button className="btn-outline-border" color="secondary"><NetworkIcon type={fieldType} /></Button></div>
      :
      <Field
        className="input-group-prepend"
        name={`${name}.type`}
        component={DropdownSelectAdapter}
        placeholder={placeholder}
        disabled={fieldValue.can_change_url === false}
        disabledValues={selectedFields || []}
        hideDisabledOptions={true}
      >
        {map(scheme, (network, type)=>{
          return <option value={type} key={type} label={<NetworkIcon type={type} />}><NetworkIcon type={type} /> {network.title}</option>
        })}
      </Field>
    }
      
    <InputField 
      meta={{submitting}} name={`${name}.handle`}
      type="text"
      placeholder={itemSettings.placeholder || "handle"}
      parse={itemSettings.parse}
    /></div>
    {subfields && map(subfields, (subfield,subname)=>(
      <InputField
        key={`${name}.${subname}`}
        meta={{submitting}} name={`${name}.${subname}`}
        type={subfield.type || 'text'}
        placeholder={subfield.placeholder || subname}
        parse={subfield.parse}
        className="input-stack-row"
      />
    ))}
    
  </div>)
}

export default SchemedField;


// WEBPACK FOOTER //
// ./src/components/SmartLinks/SchemedField.js